import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white rounded-2xl border border-divider p-4 sm:p-6 shadow-sm" }
const _hoisted_2 = { class: "flex flex-col lg:flex-row lg:items-center lg:justify-between gap-5 pb-5 border-b border-divider" }
const _hoisted_3 = { class: "flex flex-wrap items-center gap-2 mb-2" }
const _hoisted_4 = { class: "text-xs uppercase tracking-wider font-semibold px-2.5 py-0.5 rounded-full bg-beige text-active border border-active/10" }
const _hoisted_5 = { class: "text-xs text-muted flex items-center gap-1" }
const _hoisted_6 = { class: "text-2xl sm:text-3xl font-bold text-brown flex flex-wrap items-center gap-2 sm:gap-3" }
const _hoisted_7 = { class: "text-base sm:text-lg font-normal text-muted font-caudex" }
const _hoisted_8 = { class: "text-xs sm:text-sm text-alternative-gray mt-1.5 flex flex-wrap items-center gap-x-2 gap-y-1" }
const _hoisted_9 = { class: "text-brown" }
const _hoisted_10 = { class: "text-brown" }
const _hoisted_11 = { class: "font-caudex text-active" }
const _hoisted_12 = { class: "grid grid-cols-2 sm:grid-cols-4 gap-2" }
const _hoisted_13 = { class: "px-3 py-2.5 bg-secondary rounded-xl border border-divider text-center" }
const _hoisted_14 = { class: "text-[10px] sm:text-[11px] text-muted" }
const _hoisted_15 = { class: "text-sm font-bold text-active mt-0.5 font-caudex" }
const _hoisted_16 = { class: "text-xs font-normal text-brown block" }
const _hoisted_17 = { class: "px-3 py-2.5 bg-secondary rounded-xl border border-divider text-center" }
const _hoisted_18 = { class: "text-[10px] sm:text-[11px] text-muted" }
const _hoisted_19 = { class: "text-sm font-bold text-brown mt-0.5 font-caudex" }
const _hoisted_20 = { class: "px-3 py-2.5 bg-secondary rounded-xl border border-divider text-center" }
const _hoisted_21 = { class: "text-[10px] sm:text-[11px] text-muted" }
const _hoisted_22 = { class: "text-sm font-bold text-brown mt-0.5 font-caudex" }
const _hoisted_23 = { class: "text-[11px] text-muted block" }
const _hoisted_24 = { class: "px-3 py-2.5 bg-secondary rounded-xl border border-divider text-center" }
const _hoisted_25 = { class: "text-[10px] sm:text-[11px] text-muted" }
const _hoisted_26 = { class: "text-sm font-bold text-gold mt-0.5 font-caudex" }
const _hoisted_27 = { class: "text-[11px] text-muted block" }
const _hoisted_28 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4 mt-5" }
const _hoisted_29 = { class: "flex items-start gap-3.5" }
const _hoisted_30 = { class: "flex flex-wrap items-center gap-2" }
const _hoisted_31 = { class: "text-xs font-bold uppercase tracking-wider text-muted" }
const _hoisted_32 = { class: "text-sm sm:text-base font-bold text-brown mt-1" }
const _hoisted_33 = { class: "text-xs text-alternative-gray mt-1 leading-relaxed" }
const _hoisted_34 = { class: "flex items-start gap-3.5" }
const _hoisted_35 = { class: "flex flex-wrap items-center gap-2" }
const _hoisted_36 = { class: "text-xs font-bold uppercase tracking-wider text-muted" }
const _hoisted_37 = { class: "text-sm sm:text-base font-bold text-brown mt-1" }
const _hoisted_38 = { class: "text-brown" }
const _hoisted_39 = { class: "text-brown" }

import { capitalize, computed } from "vue";
import { FavorableDayReport, MonthDayReport } from "@/types/calculators";
import { useI18n } from "vue-i18n";
import { useLangStore } from "@/stores/langStore";
import { formatDate, getWeekdayName } from "@/utils/date";


export default /*@__PURE__*/_defineComponent({
  __name: 'DayParamsComponent',
  props: {
    selectedCard: {},
    dayDetailsInfo: {},
    timezone: {},
    latitude: {},
    longitude: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();
const langStore = useLangStore();

const isBadBackground = computed(() => {
  const badCodes = ["下下", "下"];

  return badCodes.includes(
    props.dayDetailsInfo.day_report.general.yi_ji_activities.conflict_grade
      .rank_code
  );
});
const isBaziBad = computed(() => {
  return (
    props.dayDetailsInfo.day_report.personal.verdict.split(" ")[0] === "bad"
  );
});

return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)("calculators.personal-date.full-day-report.title")), 1),
          _createElementVNode("span", _hoisted_5, [
            _createElementVNode("span", null, "📍 " + _toDisplayString(__props.timezone), 1),
            _createElementVNode("span", null, " • " + _toDisplayString(__props.longitude.toFixed(2)) + "°E, " + _toDisplayString(__props.latitude.toFixed(2)) + "°N ", 1)
          ])
        ]),
        _createElementVNode("h1", _hoisted_6, [
          _createElementVNode("span", null, _toDisplayString(_unref(formatDate)(__props.selectedCard.date, _unref(langStore).current)), 1),
          _createElementVNode("span", _hoisted_7, " (" + _toDisplayString(capitalize(_unref(getWeekdayName)(__props.selectedCard.date, _unref(langStore).current))) + ") ", 1)
        ]),
        _createElementVNode("p", _hoisted_8, [
          _createElementVNode("span", null, [
            _createTextVNode(_toDisplayString(_unref(t)("calculators.personal-date.full-day-report.month-calendar")) + " ", 1),
            _createElementVNode("strong", _hoisted_9, _toDisplayString(__props.selectedCard.lunar_short), 1)
          ]),
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "text-muted" }, "•", -1)),
          _createElementVNode("span", null, [
            _createTextVNode(_toDisplayString(_unref(t)("calculators.personal-date.full-day-report.season")) + " ", 1),
            _createElementVNode("strong", _hoisted_10, _toDisplayString(__props.dayDetailsInfo.day_report.general.solar_term.current.name), 1),
            _createTextVNode(" (" + _toDisplayString(_unref(t)("calculators.personal-date.full-day-report.current-solar-day", {
                day: __props.dayDetailsInfo.day_report.general.solar_term
                  .days_since_month_jie,
              })) + ") ", 1)
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "text-muted" }, "•", -1)),
          _createElementVNode("span", null, [
            _createTextVNode(_toDisplayString(_unref(t)("calculators.personal-date.full-day-report.pillars")) + " ", 1),
            _createElementVNode("strong", _hoisted_11, _toDisplayString(__props.selectedCard.pillars.year) + " • " + _toDisplayString(__props.selectedCard.pillars.month) + " • " + _toDisplayString(__props.selectedCard.pillars.day), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(t)("calculators.personal-date.full-day-report.officers")), 1),
          _createElementVNode("div", _hoisted_15, [
            _createTextVNode(_toDisplayString(__props.dayDetailsInfo.day_report.general.twelve_jian_chu_officer.name) + " ", 1),
            _createElementVNode("span", _hoisted_16, " (" + _toDisplayString(__props.dayDetailsInfo.day_report.general.twelve_jian_chu_officer
                  .title_ua) + ") ", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(t)("calculators.personal-date.full-day-report.constellations")), 1),
          _createElementVNode("div", _hoisted_19, [
            _createTextVNode(_toDisplayString(__props.dayDetailsInfo.day_report.general.constellation_28.full_name) + " ", 1),
            _createElementVNode("span", {
              class: _normalizeClass(["text-xs font-normal block", 
                __props.dayDetailsInfo.day_report.general.constellation_28.is_auspicious
                  ? 'text-success'
                  : 'text-error'
              ])
            }, _toDisplayString(__props.dayDetailsInfo.day_report.general.constellation_28.is_auspicious
                  ? _unref(t)("calculators.personal-date.full-day-report.favor-const")
                  : _unref(t)("calculators.personal-date.full-day-report.taboo-const")), 3)
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(t)("calculators.personal-date.full-day-report.month-hexagram")), 1),
          _createElementVNode("div", _hoisted_22, [
            _createTextVNode(_toDisplayString(__props.dayDetailsInfo.day_report.general.month_hexagram_pi_gua.name) + " ", 1),
            _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(t)(
                  "calculators.personal-date.full-day-report.yin-yang-hexagram",
                  {
                    yin: __props.dayDetailsInfo.day_report.general.month_hexagram_pi_gua
                      .yin_lines,
                    yang: __props.dayDetailsInfo.day_report.general
                      .month_hexagram_pi_gua.yang_lines,
                  }
                )), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, _toDisplayString(_unref(t)("calculators.personal-date.full-day-report.sun-general")), 1),
          _createElementVNode("div", _hoisted_26, [
            _createTextVNode(_toDisplayString(__props.dayDetailsInfo.day_report.general.sun_position_yue_jiang.branch) + " (" + _toDisplayString(__props.dayDetailsInfo.day_report.general.sun_position_yue_jiang
                .spirit_general_name) + ") ", 1),
            _createElementVNode("span", _hoisted_27, _toDisplayString(__props.dayDetailsInfo.day_report.general.sun_position_yue_jiang
                  .palace_name), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", {
        class: _normalizeClass(["p-4 sm:p-5 rounded-xl border", 
          isBadBackground.value
            ? 'border-error/30 bg-[#FDF7F7]'
            : 'border-success/30 bg-[#F6FAF7]'
        ])
      }, [
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", {
            class: _normalizeClass(["w-11 h-11 sm:w-12 sm:h-12 rounded-xl flex items-center justify-center shrink-0 font-bold text-xl", 
              isBadBackground.value
                ? 'bg-error/10 text-error'
                : 'bg-success/10 text-success'
            ])
          }, _toDisplayString(isBadBackground.value ? "✕" : "✓"), 3),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("span", _hoisted_31, _toDisplayString(_unref(t)(
                    "calculators.personal-date.full-day-report.lunar-day-background"
                  )), 1),
              _createElementVNode("span", {
                class: _normalizeClass(["px-2 py-0.5 rounded text-[11px] font-bold text-white", isBadBackground.value ? 'bg-error' : 'bg-success'])
              }, _toDisplayString(_unref(t)("calculators.personal-date.top-days.rang")) + " " + _toDisplayString(__props.dayDetailsInfo.day_report.general.yi_ji_activities
                    .conflict_grade.rank_code), 3)
            ]),
            _createElementVNode("h3", _hoisted_32, _toDisplayString(__props.dayDetailsInfo.day_report.general.yi_ji_activities
                  .conflict_grade.rank_title), 1),
            _createElementVNode("p", _hoisted_33, _toDisplayString(__props.dayDetailsInfo.day_report.general.yi_ji_activities
                  .conflict_grade.explanation), 1)
          ])
        ])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["p-4 sm:p-5 rounded-xl border", 
          isBaziBad.value
            ? 'border-error/30 bg-[#FDF7F7]'
            : 'border-success/30 bg-[#F6FAF7]'
        ])
      }, [
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", {
            class: _normalizeClass(["w-11 h-11 sm:w-12 sm:h-12 rounded-xl flex items-center justify-center shrink-0 font-bold text-lg sm:text-xl", 
              isBaziBad.value
                ? 'bg-error/10 text-error'
                : 'bg-success/10 text-success'
            ])
          }, _toDisplayString(__props.dayDetailsInfo.day_report.personal.compatibility_score) + "% ", 3),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("span", _hoisted_36, _toDisplayString(_unref(t)(
                    "calculators.personal-date.full-day-report.personal-bazi-compatibility"
                  )), 1),
              _createElementVNode("span", {
                class: _normalizeClass(["px-2 py-0.5 rounded text-[11px] font-bold text-white", isBaziBad.value ? 'bg-error' : 'bg-success'])
              }, _toDisplayString(__props.dayDetailsInfo.day_report.personal.verdict.split(" ")[0]), 3)
            ]),
            _createElementVNode("h3", _hoisted_37, _toDisplayString(__props.dayDetailsInfo.day_report.personal.verdict), 1),
            _createVNode(_component_i18n_t, {
              keypath: "calculators.personal-date.full-day-report.day-master-takes-energy",
              tag: "p",
              class: "text-xs text-alternative-gray mt-1 leading-relaxed"
            }, {
              dayMaster: _withCtx(() => [
                _createElementVNode("strong", _hoisted_38, _toDisplayString(__props.dayDetailsInfo.user_natal_summary.day_master.element) + " (" + _toDisplayString(__props.dayDetailsInfo.user_natal_summary.day_master.element) + ") ", 1)
              ]),
              stemGod: _withCtx(() => [
                _createElementVNode("strong", _hoisted_39, _toDisplayString(__props.dayDetailsInfo.day_report.personal.ten_gods
                      .relative_to_day_master.day_stem_ten_god.name) + " (" + _toDisplayString(__props.dayDetailsInfo.day_report.personal.ten_gods
                      .relative_to_day_master.day_stem_ten_god.ua) + ") ", 1)
              ]),
              _: 1
            })
          ])
        ])
      ], 2)
    ])
  ]))
}
}

})